import { useYChannelStoreHook } from "@/distributions/universe/store/channel";

import getChannelConfig from "../channels";

/**
 * 动态加载渠道组件
 * @param componentName 组件名称，例如 "Footer" 或 "Navbar"
 * @param context
 * @returns 包含组件和 props 的对象
 */
export async function loadChannelComponent(
  componentName: string,
  callerPath?: string
) {
  const channel = useYChannelStoreHook();
  const channelId = channel.channel;
  const channelConfig = getChannelConfig(channelId);
  const componentConfig =
    channelConfig?.configs?.components?.[componentName] || {};

  // 获取当前页面的路径

  let Component = componentConfig?.component || null;
  const props = componentConfig?.props || {};

  // 动态加载本地组件
  if (!Component && callerPath) {
    // 提取调用文件的目录（转换为相对路径）
    let callerDir = callerPath.replace(/^http:\/\/[^/]+/, ""); // 去掉主机部分
    callerDir = callerDir.substring(0, callerDir.lastIndexOf("/")); // 获取目录部分

    // 所有本地组件（静态定义的路径）
    const allLocalComponents = import.meta.glob("@consumerY/**/*.vue") as {
      default: any;
    };
    // 根据调用文件的目录筛选出符合条件的组件
    const componentPath = Object.keys(allLocalComponents).find(
      path =>
        path.startsWith(callerDir) && path.endsWith(`${componentName}.vue`)
    );

    try {
      if (componentPath) {
        Component = (await allLocalComponents[componentPath]())?.default;
      }
    } catch (error) {
      console.warn(`相对目录./components/${componentName}.vue 不存在.`);
    }
  }
  // 如果本地组件未找到，尝试加载全局组件
  try {
    if (!Component) {
      const globalComponents = import.meta.glob(
        "@consumerY/components/**/*.vue"
      ) as { default: any };
      const componentPath = Object.keys(globalComponents).find(path =>
        path.endsWith(`${componentName}.vue`)
      );
      if (componentPath) {
        Component = (await globalComponents[componentPath]()).default;
      }
    }
  } catch (error) {
    console.error(
      `找不到全局consumer/y/components文件夹下 ${componentName}.vue组件的存在.`
    );
    throw new Error(`组件 ${componentName} 可能不存在.`);
  }

  if (!Component) {
    console.error(`找不到 ${componentName}.vue组件的存在.`);
    return Promise.reject(`找不到 ${componentName}.vue组件的存在.`);
  }
  return { Component, props };
}
